const
  NAME               = 'carousel',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME],

  GALLERY_COUNTER    = 'squido-carousel-galleries-opened',
  NAVIGATE_BACK      = 'squido-carousel-gallery-nav-back'
;

var lastAdvMobileSlide$;

class Carousel {
  constructor(element$, globalOptions) {
    var swiper, selector, autoplay, realSlidesPerView, options;

    this._element$ = element$;
    this._nextButton$ = $('.swiper-button-next', element$);
    this._prevButton$ = $('.swiper-button-prev', element$);
    this._length = element$.find('.swiper-slide').length;
    this._gtngHandler = this.goToNextGallery.bind(this);
    this._addSwiperListener = this.addSwiperListener.bind(this);
    this._onSwipeLeft = this.onSwipeLeft.bind(this);
    this._historyBack = this.historyBack.bind(this);
    this._checkDirection = this.checkDirection.bind(this);

    // NOTE: Creating a local copy of swiper's configuration objects
    options = {};
    $.extend(true, options, globalOptions);

    // NOTE: Calculate the real slides per view (case of multirow presentation)
    realSlidesPerView = this.calculateRealSlidesPerView(options);

    // NOTE: Hide pagination and arrow buttons if there is not scroll
    if (!this.hasLoop(realSlidesPerView)) {
      if (options.breakpoints["700"]) {options.breakpoints["700"].pagination = null;}
      options.prevButton = null;
      options.nextButton = null;
      this._element$.find('.swiper-pagination').hide();
      this._element$.find('.swiper-button-prev').hide();
      this._element$.find('.swiper-button-next').hide();
    }

    // NOTE: Loop configuration
    // FUTURE: la posibilidad de configuración del loop mediante data-atributo.
    // loop = !!element$.data('voc-carousel-loop');

    // NOTE: Si es versión móvil y el swipper se contrae a 2 filas, no tiene loop
    if (!this.hasLoop(realSlidesPerView)) {options.loop = false;}

    // NOTE: Autoplay configuration
    autoplay = Number(element$.data('voc-carousel-autoplay'));
    if (!isNaN(autoplay)) {options.autoplay = autoplay;}

    // NOTE: Sync carousel configuration
    selector = element$.data('voc-carousel-sync-selector');
    if (selector) {
      this._synced$ = $(selector);
      this._synced$.children(':not(:first-child)').hide();
    }

    swiper = element$.swiper(Object.create(options));

    swiper.on('slideChangeEnd', this.onSlideChangeEnd.bind(this));
    swiper.on('slideChangeStart', this.onSlideChangeStart.bind(this));
    this._swiper = swiper;
    element$.data('swiper', swiper);

    this.onInitCheckSession();
    this.hidePrevButtonIfNeeded(swiper);
    this.onInit();
  }

  onInitCheckSession() {
    if ('sessionStorage' in window) {
      if (!window.sessionStorage.getItem(GALLERY_COUNTER)) {
        window.sessionStorage.setItem(GALLERY_COUNTER, 0);
      }
      if (window.sessionStorage.getItem(NAVIGATE_BACK)) {
        window.sessionStorage.removeItem(NAVIGATE_BACK);
        var i = this._length - 2;
        this._swiper.slideTo(i, 50);
      }
    }
  }

  onInit() {
    if (this.getSessionStorageCounter() > 0 && this._swiper.activeIndex === 0) {
      this.deleteClass(this._prevButton$);
      this._prevButton$.on('click', this._historyBack);
      this._swiper.on('sliderMove', _.debounce(this._onSwipeLeft, 300));
    }
  }

  onSlideChangeStart(event) {
    var hasNextGallery, slide$, eq, key;

    eq             = event.activeIndex > this._length ? 1 : event.activeIndex === 0 ? this._length : event.activeIndex;
    slide$         = this._element$.find('.swiper-slide').eq(eq);
    hasNextGallery = !!$('.voc-next-gallery', slide$).length;

    if (eq > 0) {this._prevButton$.show();}

    this.hidePrevButtonIfNeeded(this._swiper);
    key = this.getSessionStorageCounter();

    if (this._swiper.activeIndex === 0 && key > 0) {
      this.deleteClass(this._prevButton$);
      this.onSlideBeginning();
    } else {
      this._swiper.off('sliderMove');
      this._prevButton$.off('click', this._historyBack);
    }

    if (hasNextGallery) {
      this.deleteClass(this._nextButton$);
      this._nextButton$.one('click', this._gtngHandler);
      this._swiper.once('slideChangeStart', this._addSwiperListener);
    } else {
      this._nextButton$.off('click', this._gtngHandler);
      this._swiper.off('slideChangeEnd', this._addSwiperListener);
     }
  }

  hidePrevButtonIfNeeded(swiper) {
    var key = this.getSessionStorageCounter();
    if (swiper.activeIndex === 0 && key === 0) {
      this._prevButton$.hide();
    }
  }

  onSlideChangeEnd(event) {
    var track, ads, eq, app, moveRefresh, slide$;

    app         = Voonto.getInstance();
    eq          = event.activeIndex > this._length ? 1 : event.activeIndex === 0 ? this._length : event.activeIndex;
    slide$      = this._element$.find('.swiper-slide').eq(eq);
    track       = slide$.data('voc-vtm-track');
    ads         = slide$.data('voc-vam-refresh');
    moveRefresh = slide$.data('voc-vam-move-and-refresh');

    if (moveRefresh) {
      if (!slide$.find('[data-voc-vam]').length) {
        let ads$, elNoAds$;
        elNoAds$ = slide$.find('.voc-w300');
        ads$     = this._element$.find('[data-voc-vam]');

        if (ads$.length) {
          elNoAds$.append(ads$);
          setTimeout(() => app.trigger('vam:refresh', moveRefresh), 0);
        }
      }
    }

    // NOTE: Increase adv container height to 600px if the device is mobile
    if (Voonto.is.mobile()) {
      this.mobileAdvertisingResize(moveRefresh, slide$);
    }

    if (track) {app.trigger('vtm:track', track);}
    if (ads)   {app.trigger('vam:refresh', ads);}

    if (this._synced$) {
      this._synced$.children(':visible').hide();
      this._synced$.children().eq(eq - 1).show();
    }
  }

  addSwiperListener() {
    this._swiper.on('sliderMove', _.debounce(this._checkDirection, 300));
  }

  checkDirection() {
     if (this._swiper.swipeDirection === 'next') {
      this.goToNextGallery();
    }
  }

  goToNextGallery() {
    var link;
    link = $('.voc-next-gallery > a', this._element$).attr('href');
    document.location = link;
    this.storeCounterSession();
    window.sessionStorage.removeItem(NAVIGATE_BACK);
  }

  storeCounterSession() {
    if ('sessionStorage' in window) {
      if (window.sessionStorage.getItem(GALLERY_COUNTER)) {
        var key = this.getSessionStorageCounter() + 1;
        window.sessionStorage.setItem(GALLERY_COUNTER, key);
      }
    }
  }

  getSessionStorageCounter() {
    var value = window.sessionStorage.getItem(GALLERY_COUNTER).split();
    return Number(value[0]);
  }

  deleteClass(button$) {
    button$.removeClass('swiper-button-disabled');
  }

  onSlideBeginning() {
    this._swiper.on('sliderMove', _.debounce(this._onSwipeLeft, 300));
    this._prevButton$.one('click', this._historyBack);
  }

  onSwipeLeft(swiper) {
    if (swiper.swipeDirection === 'prev') {
      this.historyBack();
    }
  }

  historyBack() {
    var key = this.getSessionStorageCounter() - 1;
    window.sessionStorage.setItem(GALLERY_COUNTER, key);
    window.sessionStorage.setItem(NAVIGATE_BACK, true);
    window.history.back();
 }

  hasLoop(realSlidesPerView) {
    return Voonto.is.mobile() ? this._length >= realSlidesPerView : this._length > realSlidesPerView;
  }

  calculateRealSlidesPerView(options){
    var realSlidesPerView = 0;

    if (!isNaN(options.slidesPerView)) {
      var slidesPerRow, slidesPerColumn;

      if (Voonto.is.mobile() && options.breakpoints["700"]) {
        var slidesPerRowMobile, slidesPerColumnMobile;
        slidesPerRowMobile    = options.breakpoints["700"].slidesPerView;
        slidesPerColumnMobile = options.breakpoints["700"].slidesPerColumn;

        if (!isNaN(slidesPerRowMobile))    {slidesPerRow    = slidesPerRowMobile;}
        if (!isNaN(slidesPerColumnMobile)) {slidesPerColumn = slidesPerColumnMobile;}
      } else if (Voonto.is.tablet() && options.breakpoints["1039"]){
        var slidesPerRowTablet, slidesPerColumnTablet;
        slidesPerRowTablet    = options.breakpoints["1039"].slidesPerView;
        slidesPerColumnTablet = options.breakpoints["1039"].slidesPerColumn;

        if (!isNaN(slidesPerRowTablet))    {slidesPerRow    = slidesPerRowTablet;}
        if (!isNaN(slidesPerColumnTablet)) {slidesPerColumn = slidesPerColumnTablet;}
      } else {
        slidesPerRow    = options.slidesPerView;
        slidesPerColumn = options.slidesPerColumn;
      }

      if (!isNaN(slidesPerColumn)){
        realSlidesPerView = slidesPerRow * slidesPerColumn;
      } else {realSlidesPerView = slidesPerRow;}
    }

    return realSlidesPerView;
  }

  mobileAdvertisingResize(moveRefresh, currentSlide) {
    if (moveRefresh) {
      if (currentSlide.find('.voc-figure-container').length) {
        lastAdvMobileSlide$ = currentSlide.find('.voc-figure-container');
        lastAdvMobileSlide$.addClass("voc-figure-container--600h");
      }
    } else if (lastAdvMobileSlide$) {
      lastAdvMobileSlide$.removeClass("voc-figure-container--600h");
      lastAdvMobileSlide$ = null;
    }
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(options) {
    return this.each(function() {
      new Carousel($(this), options);
    });
  }
}

$.fn[NAME]             = Carousel._jQueryInterface;
$.fn[NAME].Constructor = Carousel;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return Carousel._jQueryInterface;
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/plugins/carousel.js